import type { AppConfig } from '@/types';

export const appConfigData: AppConfig = {
  idleTimeout: 1500,
  color: '35 31 32',
  backgroundColor: '230 245 241',
};
